import DesignTokens from '@tableau/design-tokens';
import {TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

const cssPrefix = 'UserSettingsPage';

export namespace UserSettingsStyle {
  export const userSettingsRoot = cssClass(cssPrefix, 'root', {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'auto',
    paddingBottom: '30px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, TabStyles.Colors.White),
    position: 'absolute',
    $nest: {
      'a': {
        textDecoration: 'underline'
      },
      'table': {
        borderSpacing: 0,
        $nest: {
          '&.tb-root-table': {
            marginTop: 0,
            marginBottom: 30,
          },
          'tbody': {
            $nest: {
              'tr': {
                verticalAlign: 'top',
                $nest: {
                  'td': {
                    paddingLeft: TabStyles.Spacing.MediumSpace,
                    paddingRight: TabStyles.Spacing.MediumSpace,
                    $nest: {
                      '&.tb-nested-table': {
                        padding: 0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });

  export const titleText = cssClass(cssPrefix, 'title', {
    fontFamily: 'BentonSans-Book',
    fontSize: '18px',
    textAlign: 'left',
    paddingBottom: '24px',
    paddingTop: '24px',
    paddingLeft: '24px',
    marginBottom: '0px'
  });

  export const labelText = cssClass(cssPrefix, 'label', {
    color: applyColor(DesignTokens.color.font.default.default, CommonStyles.Colors.Black),
    fontFamily: 'BentonSans-Medium',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    textAlign: 'left',
    paddingBottom: '16px',
    width: '150px',
    paddingLeft: 24,
    $nest: {
      'h4': SpaceContainerStyles.NoStyleHeader
    }
  });

  export const labelWithInfoButtonText = cssClass(cssPrefix, 'label', {
    position: 'relative',
    top: '-3.5px',
  });

  export const emailInfoButton = cssClass(cssPrefix, 'button', {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    width: '74px !important'
  });

  export const usernameInfoButton = cssClass(cssPrefix, 'button', {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    width: '96px !important'
  });

  export const tbody = cssClass(cssPrefix, 'body', {
    paddingLeft: CommonStyles.Sizes.DefaultSpace + CommonStyles.Sizes.LargeSpace,
    paddingRight: CommonStyles.Sizes.MediumSpace,
  });

  export const detailsValue = cssClass(cssPrefix, 'details-value', {
    width: '800px',
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: '16px !important',
  });

  export const detailsValueSmallPadding = cssClass(cssPrefix, 'details-value', {
    width: '800px',
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: '8px !important',
  });

  export const buttons = cssClass(cssPrefix, 'buttons', {
    paddingBottom: '16px !important',
    paddingTop: '8px !important'
  });

  export const cancelButton = cssClass(cssPrefix, 'cancelButton', {
    paddingRight: '12px !important',
    paddingBottom: '16px !important',
    paddingTop: '8px !important'
  });

  export const dropdown = cssClass(cssPrefix, 'dropdown', {
    width: '250px'
  });

  export const dropdownList = cssClass(cssPrefix, 'dropdownList', {
    maxHeight: '421.2px',
    overflowX: 'hidden'
  });

  export const checkBox = cssClass(cssPrefix, 'checkbox', {
    marginLeft: '0px !important',
  });

  export const itemTableName = cssClass(cssPrefix, 'itemTable', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'InlineBlock',
  });

  export const tableMultilineWithSeparatorRow = cssClass(cssPrefix, 'multiLine', {
    paddingTop: CommonStyles.Sizes.SmallSpace,
    paddingBottom: CommonStyles.Sizes.SmallSpace,
    paddingLeft: CommonStyles.Sizes.MediumSpace,
    paddingRight: CommonStyles.Sizes.MediumSpace,
    height: CommonStyles.Sizes.RowHeight,
    verticalAlign: 'middle',
    borderBottom: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.DividerLineColor)}`,
  });

  export const tableHeaderLine = cssClass(cssPrefix, 'tableHeader', {
    paddingTop: CommonStyles.Sizes.DefaultSpace,
    paddingBottom: CommonStyles.Sizes.DefaultSpace,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, CommonStyles.Colors.White),
    borderBottom: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.DividerLineColor)}`,
    borderTop: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.DividerLineColor)}`,
  });

  export const securityButton = cssClass(cssPrefix, 'securityButton', {
    textAlign: 'right',
    paddingLeft: '510px',
    paddingBottom: '20px',
    paddingTop: '10px'
  });

  export const accountSectionContainer = cssClass(cssPrefix, 'account-section-container', {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '0px',
    paddingBottom: '20px'
  });

  export const accountSectionLabel = cssClass(cssPrefix, 'account-section-label', {
    display: 'flex',
    alignItems: 'center',
    width: '150px',
    color: applyColor(DesignTokens.color.font.default.default, CommonStyles.Colors.Black),
    fontFamily: 'BentonSans-Medium',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    paddingLeft: '12px'
  });

  export const accountSectionValue = cssClass(cssPrefix, 'account-section-value', {
    marginLeft: '23px',
    fontSize: CommonStyles.Sizes.NormalFontSize
  });

  export const settingsContainer = cssClass(cssPrefix, 'settings-container', {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '13px',
    paddingRight: TabStyles.Spacing.MediumSpace,
    margin: 0
  });

  export const settingsSection = cssClass(cssPrefix, 'settings-section', {
    width: '100%'
  });


  export const settingRow = cssClass('UserSettings', 'setting-row', {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  });

  export const settingItem = cssClass('UserSettings', 'setting-item', {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '24px',
    padding: '24px 0',
    borderBottom: `1px solid `+applyColor(DesignTokens.color.elevation.border.default.subtle, '#e0e0e0'),
  });

  export const settingsLabelText =cssClass('UserSettings', 'setting-item', {
    color: applyColor(DesignTokens.color.font.default.default, CommonStyles.Colors.Black),
    fontFamily: 'BentonSans-Medium',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    textAlign: 'left',
    paddingBottom: '16px',
    width: '150px',
    flexShrink: 0,
    paddingRight: '12px',
    $nest: {
      'h4': SpaceContainerStyles.NoStyleHeader
    }
  });

  export const settingsLabelDescription =cssClass('UserSettings', 'setting-item', {
    paddingLeft: '12px',
  });

  export const personalAccessTokenForm =cssClass('UserSettings', 'setting-item', {
    padding: '1px 12px 1px 12px'
  });
}